export enum DeviceCommunicationMethod {
    Comms,
    Sms,
}

export enum ThirdPartyMessagingProvider {
    WirelessLogic,
    Aeris,
    Twilio,
    Tele2,
}

export enum DeviceMessageDirection {
    Outbound,
    Inbound,
}
